/* Compte à rebours — RJ-03 (Bible §32 · TOV §13.3 · locked #14).
   Plain-label controls from the locked preset library. Three things are not
   the merchant’s to change: the 120 s absolute deadline always wins,
   « Passer et voir mon cadeau » is always shown, and the reveal is guaranteed
   whatever happens. Early opening on return is opt-in and off by default.
   The moment's name is READ from `MOMENTS` (@/lib/campaign), never restated:
   D-65 renamed all three on 11/09 and this screen said the old one for a day. */
import { useState } from 'react'
import { Card, KV, Switch } from '@/ui'
import { MOMENTS } from '@/lib/campaign'
import { Retour, Verrouille } from './parts'

const moment = (id: string) => MOMENTS.find(m => m.id === id)?.title ?? id

const DUREES = [0, 15, 30, 45]

export default function Compte() {
  const [duree, setDuree] = useState(30)
  const [ongletMasque, setOngletMasque] = useState(true)

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 720 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>
        Compte à rebours — {moment('pendant')}
      </h2>

      <KV rows={[
        ['Démarrer le compte à rebours', <span key="s"><b>à l’ouverture du lien</b> · roue / popup possibles</span>],
        ['Durée', <span key="d" style={{ display: 'inline-flex', gap: 6 }}>
          {DUREES.map(v => (
            <button key={v} type="button" className={'tab' + (duree === v ? ' on' : '')}
              onClick={() => setDuree(v)}>{v === 0 ? '0' : `${v} s`}</button>
          ))}
        </span>],
        ['Onglet masqué', <span key="o" style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>
          continuer <Switch checked={ongletMasque} onChange={e => setOngletMasque(e.currentTarget.checked)}
            aria-label="Continuer si l’onglet est masqué" />
        </span>],
        /* list-2 rider (list-2-vet) · « Ouverture anticipée au retour » left with the builder's toggle (inert since D-88) */
        ['Toujours afficher après', <span key="p"><b>120 s</b> — plafond non désactivable</span>],
        ['« Passer et voir mon cadeau »', <span key="v" style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>
          toujours affiché <Verrouille />
        </span>],
      ]} />

      <Card>
        <p className="f-help" style={{ margin: 0 }}>
          Aperçu des états&nbsp;: aucun clic → révélation à 120 s · onglet bloqué → reprise
          en ligne · retour observé → décompte inchangé · Passer → révélation immédiate.
        </p>
      </Card>
    </div>
  )
}
